export default __webpack_public_path__ + "images/1d9c0797f9dc88b213b2cf2676ba0cf1.svg";